export default {

    rad: function (x) {
        return x * Math.PI / 180;
    },

    getDistance: function (p1, p2) {
        var R = 6378137; // Earth’s mean radius in meter
        var dLat = this.rad(p2.lat - p1.lat);
        var dLong = this.rad(p2.lng - p1.lng);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.rad(p1.lat)) * Math.cos(this.rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d; // returns the distance in meter
    },

    getZoomLevelByDistance: function (meters) {
        var zoomfactor = 1;
        /*if (meters < 1128) { zoomfactor = 14; }*/
        /*else*/ if ((meters >= 0) && (meters < 2256)) { zoomfactor = 14; }
        else if ((meters > 2256) && (meters < 4513)) { zoomfactor = 13; }
        else if ((meters > 4513) && (meters < 9027)) { zoomfactor = 12; }
        else if ((meters > 9027) && (meters < 18055)) { zoomfactor = 11; }
        else if ((meters > 18055) && (meters < 36111)) { zoomfactor = 10; }
        else if ((meters > 36111) && (meters < 72223)) { zoomfactor = 9; }
        else if ((meters > 72223) && (meters < 144447)) { zoomfactor = 8; }
        else if ((meters > 144447) && (meters < 288895)) { zoomfactor = 7; }
        else if ((meters > 288895) && (meters < 577790)) { zoomfactor = 6; }
        else if ((meters > 577790) && (meters < 1155581)) { zoomfactor = 5; }
        else if ((meters > 1155581) && (meters < 2311162)) { zoomfactor = 4; }
        else if ((meters > 2311162) /*&& (meters < 4622324)*/) { zoomfactor = 1; }
        /*else if (meters > 4622324) { zoomfactor = 1; }*/
        return zoomfactor;
    },

    convertMilesIntoMeters: (miles) => {
        let meters = 1609.344 * parseFloat(miles)
        return meters;
    }
}